var Rm5ExportTableCell, rm5ExportConfig, rm5TbodyCells, _getCellFootnotes;

rm5ExportConfig = require('lib/rm5_export_config');

rm5TbodyCells = rm5ExportConfig.tbodyCells;

Rm5ExportTableCell = rm5ExportConfig.Rm5ExportTableCell;

_getCellFootnotes = function(cell, footnotes) {
  var attribute, cellFootnotes, cellPossibleAttributes, _i, _len;
  cellPossibleAttributes = rm5ExportConfig.attributesMap[cell];
  cellFootnotes = [];
  for (_i = 0, _len = cellPossibleAttributes.length; _i < _len; _i++) {
    attribute = cellPossibleAttributes[_i];
    if (attribute in footnotes) {
      cellFootnotes = cellFootnotes.concat(footnotes[attribute]);
    }
  }
  cellFootnotes.sort(function(a, b) {
    return a - b;
  });
  if (!_(cellFootnotes).isEmpty()) {
    return _(cellFootnotes).unique().join(' ');
  } else {
    return '';
  }
};

module.exports = function(attributes, tableMode) {
  var cellData, cellName, cellNotes, colspan, outcomeHasFootnotes, outcomeRow, rowSchema, tableType, tableView;
  if (tableMode == null) {
    tableMode = 'regular';
  }
  tableView = attributes.tableView;
  tableType = "" + tableView + "_" + tableMode;
  rowSchema = rm5ExportConfig.theadSchemas[tableType][0];
  outcomeRow = {
    cells: []
  };
  outcomeHasFootnotes = !_(attributes.footnotes).isEmpty();
  for (cellName in rowSchema) {
    if (cellName === 'absoluteEffect') {
      colspan = tableView === 'sof_v3' ? 4 : 2;
      if (outcomeHasFootnotes) {
        cellNotes = _getCellFootnotes('impact', attributes.footnotes);
      }
      cellData = {
        textContent: rm5TbodyCells['impact'](attributes),
        colspan: colspan
      };
      if (cellNotes) {
        cellData.sup = cellNotes;
      }
      outcomeRow.cells.push(new Rm5ExportTableCell(cellData));
    } else {
      if (tableView === 'sof_v3' && cellName === 'relativeEffect') {
        continue;
      }
      if (outcomeHasFootnotes) {
        cellNotes = _getCellFootnotes(cellName, attributes.footnotes);
      }
      outcomeRow.cells.push(new Rm5ExportTableCell({
        textContent: rm5TbodyCells[cellName](attributes),
        sup: cellNotes || ''
      }));
    }
  }
  return outcomeRow;
};
